var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((5),function(i){return _c('i',{key:i,staticClass:"fas fa-star"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }